import type { schemaType as DestinosSchemaType } from '~~/shared/api/strapi/destinos/detail/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-hero.vue'

export const useToSHero = () => {
  const fromStrapiDestinosDetail = (
    data: DestinosSchemaType,
  ): propsInterface => {
    const filteredData: propsInterface = {
      image: data.attributes.hero.image.data.attributes.url,
      title: data.attributes.hero.title,
      badge: data.attributes.hero.author ?? null,
    }
    return filteredData
  }

  return { fromStrapiDestinosDetail }
}
